import { render, staticRenderFns } from "./config_renew.vue?vue&type=template&id=6d3ce012&scoped=true&"
import script from "./config_renew.vue?vue&type=script&lang=js&"
export * from "./config_renew.vue?vue&type=script&lang=js&"
import style0 from "./config_renew.vue?vue&type=style&index=0&id=6d3ce012&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ce012",
  null
  
)

export default component.exports